(() => { const og26Root = document.querySelector('.og26'); if (!og26Root) return;
(() => {
  'use strict';
  const nativeHeader = document.getElementById('shopify-section-header');
  if (nativeHeader) {
    const siteRoot = document.getElementById('main')?.parentElement;
    let lastOffset = -1, pending = false;
    const syncHeader = () => {
      pending = false;
      const offset = Math.max(0, Math.round(nativeHeader.getBoundingClientRect().bottom));
      if (siteRoot && offset !== lastOffset) { siteRoot.style.setProperty('--og26-header-offset', `${offset}px`); lastOffset = offset; }
    };
    const schedule = () => { if (!pending) { pending=true; requestAnimationFrame(syncHeader); } };
    addEventListener('scroll',schedule,{passive:true});
    addEventListener('resize',schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(nativeHeader);
    syncHeader();
  }
  og26Root.querySelectorAll('[data-carousel]').forEach(carousel => {
    const track = carousel.querySelector('.carousel-track');
    const slides = [...track.children];
    const count = carousel.querySelector('[data-count]');
    let index = 0;
    const move = step => {
      index = (index + step + slides.length) % slides.length;
      track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    carousel.querySelector('[data-prev]').addEventListener('click', () => move(-1));
    carousel.querySelector('[data-next]').addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => {
      index = slides.reduce((best,slide,i) => Math.abs(slide.offsetLeft-slides[0].offsetLeft-track.scrollLeft) < Math.abs(slides[best].offsetLeft-slides[0].offsetLeft-track.scrollLeft) ? i : best, 0);
      count.textContent = `${index + 1} / ${slides.length}`;
    }, {passive: true});
  });
})();

})();